export default function InactivityOverlay({ countdown, onDismiss }: { countdown: number; onDismiss: () => void }) {
  return (
    <div className="fixed inset-0 z-100 bg-black/80 flex items-center justify-center kiosk-fade-in" onClick={onDismiss}>
      <div className="bg-kiosk-surface rounded-3xl p-10 text-center max-w-sm mx-8 space-y-6">
        <h2 className="text-2xl font-bold text-kiosk-text">&Auml;r du fortfarande h&auml;r?</h2>
        <div className="w-24 h-24 rounded-full border-4 border-kiosk-accent flex items-center justify-center mx-auto">
          <span className="text-4xl font-bold text-kiosk-accent">{countdown}</span>
        </div>
        <p className="text-kiosk-muted">Tryck n&aring;gonstans f&ouml;r att forts&auml;tta</p>
      </div>
    </div>
  )
}
